import { useEffect, useState } from 'react';

import type { ImageSize } from './useImageSize.common';

const readViewportSize = (): ImageSize => ({
  width: window.innerWidth,
  height: window.innerHeight,
});

const useViewportSize = (): ImageSize => {
  const isClient = process.env.JS_ENV_CLIENT !== 'undefined';

  const [size, setSize] = useState<ImageSize>(
    process.env.JS_ENV_CLIENT ? readViewportSize() : { width: 0, height: 0 }
  );

  useEffect(() => {
    if (!isClient) {
      return;
    }

    const handleResize = () => {
      setSize(readViewportSize());
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    // eslint-disable-next-line consistent-return
    return () => window.removeEventListener('resize', handleResize);
  }, [isClient]);

  return size;
};

export default useViewportSize;
